import { useQuery } from '@tanstack/react-query';

import type { ListarClientesResponse } from '../pages/clientes/types.js';
import { traerTodasLasPaginas } from '../lib/paginas.js';

export type ClienteLookup = ListarClientesResponse['data'][number];

// Todos los clientes, para selects y filtros (Nuevo ticket, filtro de Tickets,
// Alta de cliente, CxC). La API corta en 100 por página y ya hay más de 80,
// así que se piden todas las páginas. Una sola llave para todas las pantallas.
export function useClientesLookup({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['clientes-lookup', 'todos'],
    queryFn: () => traerTodasLasPaginas<ClienteLookup>('/clientes'),
    enabled,
  });
}
